export default __webpack_public_path__ + "media/images/logos/m_logo_light-46ccb822914bbb0ce2d790325ffccac2.png";